import { useMemo } from 'react';
import { useReducedMotion } from './useReducedMotion';

export interface UseStaggeredAnimationOptions {
  count: number;
  baseDelay?: number;
  staggerDelay?: number;
  duration?: number;
}

export interface StaggeredItem {
  index: number;
  delay: number;
  duration: number;
  style: React.CSSProperties;
}

export function useStaggeredAnimation(options: UseStaggeredAnimationOptions): StaggeredItem[] {
  const { count, baseDelay = 0, staggerDelay = 50, duration = 300 } = options;
  const reducedMotion = useReducedMotion();

  return useMemo(() => {
    return Array.from({ length: count }, (_, index) => {
      const delay = reducedMotion ? 0 : baseDelay + index * staggerDelay;
      const actualDuration = reducedMotion ? 0 : duration;

      return {
        index,
        delay,
        duration: actualDuration,
        style: {
          animationDelay: `${delay}ms`,
          animationDuration: `${actualDuration}ms`,
          transitionDelay: `${delay}ms`,
          transitionDuration: `${actualDuration}ms`,
        },
      };
    });
  }, [count, baseDelay, staggerDelay, duration, reducedMotion]);
}

export default useStaggeredAnimation;
